import { ACTIVE_BANK_ACCOUNT_STATUS } from '../constants';
/** Whether a bank account can still be charged. */
function isActiveBankAccount(account) {
    return account.status === ACTIVE_BANK_ACCOUNT_STATUS;
}
export default isActiveBankAccount;
